var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.7809 5.21873C17.0746 5.51248 17.0746 5.98748 16.7809 6.2781L8.53086 14.5312C8.23711 14.825 7.76211 14.825 7.47148 14.5312L3.21836 10.2812C2.92461 9.98748 2.92461 9.51248 3.21836 9.22185C3.51211 8.93123 3.98711 8.9281 4.27773 9.22185L7.99648 12.9406L15.7184 5.21873C16.0121 4.92498 16.4871 4.92498 16.7777 5.21873H16.7809Z",
  fill: "#A30E47"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ee664f19b6cf828c5513ec83330cdc04.svg";